/**
 * Wave 380 · Product Analytics schema.
 *
 * Zod validation for roadmap metrics endpoint responses.
 */

import { z } from 'zod';

export const RoadmapMetricsSchema = z.object({
  window: z.object({
    since: z.string().datetime(),
    until: z.string().datetime(),
  }),
  autonomy: z.object({
    proposals_decided: z.number().int().nonnegative(),
    proposals_auto_executed: z.number().int().nonnegative(),
    anomalies_acked: z.number().int().nonnegative(),
    unknowns_curated: z.number().int().nonnegative(),
    feedback_resolved: z.number().int().nonnegative(),
    goal_plans_advanced: z.number().int().nonnegative(),
  }),
  load: z.object({
    total_human_decisions: z.number().int().nonnegative(),
    median_decision_lag_hours: z.number().int().nullable(),
    backlog_today: z.number().int().nonnegative(),
  }),
  trend: z.array(
    z.object({
      day: z.string(),
      decisions: z.number().int().nonnegative(),
      auto: z.number().int().nonnegative(),
    }),
  ),
});

export type RoadmapMetrics = z.infer<typeof RoadmapMetricsSchema>;
